<template>
    <div
        v-spinner="loading"
        class="priv-edit-container"
    >
        <v-spinner
            :opacity="0.5"
            :offset-y="150"
            size="large"
        />
        <v-tip
            ref="privTip"
            placement="top"
            clazz="priv-tip"
        >
            <template slot-scope="props">
                <span>{{ props.data }}</span>
            </template>
        </v-tip>
        <div
            v-show="!loading"
            class="priv-edit-box priv-feature-box"
        >
            <div class="priv-edit-tit">
                {{ $t('功能权限') }}
            </div>
            <div class="priv-feature-list priv-edit-border">
                <div
                    v-for="(fItem, index) in featureCheckArr"
                    :key="fItem.id"
                    class="priv-feature-item"
                >
                    <div class="priv-feature-parent">
                        <v-checkbox
                            v-model="fItem.isCheck"
                            :indeterminate="fItem.indeterminate"
                            :label="fItem.name"
                            @change="handleChange(index)"
                        />
                        <span class="priv-feature-parent-num">({{ fItem.subCheckModel.length }})</span>
                    </div>
                    <div class="priv-feature-sub">
                        <v-checkbox-group
                            v-model="fItem.subCheckModel"
                            @change="handleGroupChange(index)"
                        >
                            <v-checkbox
                                v-for="subItem in fItem.subCheckArr"
                                :key="subItem.id"
                                :value="subItem.id"
                                @change="subCheckChange(index, subItem)"
                            >
                                <!-- <span v-tip:privTip.hover.delay="getPrivTip(subItem)" v-if="hasMultiPri(subItem)">
                                    {{ subItem.name }}
                                </span>
                                <span v-else>{{ getPrivTip(subItem) }}</span> -->
                                <span>
                                    {{ getPrivTip(subItem) }}
                                    <i
                                        v-if="subItem.ab"
                                        class="priv-feature-new-tip"
                                    />
                                </span>
                                <v-icon
                                    v-if="subItem.alertTip"
                                    v-tip:privTip.hover.delay="subItem.alertTip"
                                    name="v-error"
                                    class="priv-alert-icon"
                                />
                            </v-checkbox>
                        </v-checkbox-group>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="showDataPriv"
            class="priv-edit-box priv-data-box"
        >
            <div class="priv-edit-tit">
                {{ $t('数据权限') }}
            </div>
            <div class="priv-edit-border">
                <div class="priv-data-tip">
                    {{ $t('设置【数据权限】前请先在左侧勾选对应的【功能权限】') }}
                </div>
                <div class="priv-data-list">
                    <div
                        v-for="item in dataPrivArr"
                        :key="item.id"
                        class="priv-data-item"
                    >
                        <div class="priv-data-tit">
                            <div class="priv-data-tit-txt">
                                {{ item.name }}
                            </div>
                            <div class="priv-data-tit-line" />
                        </div>
                        <div
                            v-if="mktPackage(item.setArr)"
                            class="priv-data-tit-tip"
                        >
                            <div class="priv-data-tit-tipText">
                                "{{ item.name }}"{{ $t('决定了可在各营销功能中使用的数据范围。若当前配置不满足需求，可前往') }}
                                <a
                                    href="/ea/access/datasourceRule/index"
                                    class="priv-data-tit-tipUrl"
                                    target="_blank"
                                >{{ $t('营销数据源共享') }}</a>
                                {{ $t('为员工赋予额外权限') }}
                            </div>
                        </div>
                        <div
                            v-for="(sItem, sIndex) in item.setArr"
                            :key="sItem.id"
                            :class="{ 'priv-data-choice-wrap': showOldTips(sItem) }"
                            class="priv-data-choice"
                        >
                            <div
                                :title="sItem.name"
                                class="priv-data-choice-label"
                            >
                                {{ sItem.name }}
                            </div>
                            <!-- <div class="priv-data-choice-options">
                                <v-select
                                    v-model="oItem.currVal"
                                    v-for="oItem in sItem.optArr"
                                    :key="oItem.id"
                                    :options="oItem.options"
                                    :inline="true"
                                    class="priv-data-choice-select"
                                    :class="getAnimateClass(sItem.id, oItem)"
                                    :placeholder="oItem.placeholder"
                                    :disabled="oItem.disabled"
                                    @change="selectChange(item.id, sIndex, oItem.id, oItem.currVal)"
                                >
                                    <template slot-scope="props" slot="header">
                                        <span v-if="oItem.disabled">
                                            {{ oItem.placeholder }}
                                        </span>
                                        <span v-else>{{ oItem.operateTxt }}： {{ props.item.text }}</span>
                                    </template>
                                </v-select>
                            </div> -->
                            <div class="priv-data-choice-options">
                                <v-select
                                    v-for="oItem in sItem.optArr"
                                    :key="oItem.id"
                                    v-model="oItem.currVal"
                                    :multiple="oItem.isMulti"
                                    :options="oItem.options"
                                    :inline="true"
                                    :class="getAnimateClass(sItem.id, oItem)"
                                    :placeholder="oItem.placeholder"
                                    :disabled="oItem.disabled"
                                    @change="selectChange(item.id, sIndex, oItem.id, oItem.currVal)"
                                    @select="selectClick(oItem)"
                                    class="priv-data-choice-select"
                                >
                                    <template
                                        slot="header"
                                        slot-scope="props"
                                    >
                                        <span v-if="oItem.disabled">
                                            {{ oItem.placeholder }}
                                        </span>
                                        <span v-else-if="oItem.isMulti">
                                            {{ oItem.operateTxt }}： {{ getMultiSelectTxt(oItem) }}
                                        </span>
                                        <span v-else>{{ oItem.operateTxt }}： {{ props.item.text }}</span>
                                    </template>
                                </v-select>
                            </div>
                            <div
                                v-if="showOldTips(sItem)"
                                class="priv-data-old-tips"
                            >
                                <span class="priv-data-old-tips-txt">{{ oldTips[sItem.id].tips }}</span>
                                <a
                                    :href="oldTips[sItem.id].link"
                                    target="_blank"
                                >{{ $t('查看旧版') }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        reqParam: {
            type: Object,
            default: () => {},
        },

        // 有错误的bo_id 下拉框要显示红框
        errBoId: {
            type: Number,
            default: -1,
        },
    },
    data() {
        return {
            loading: false,
            featurePrivOri: {},
            featureCheckArr: [],
            dataPrivOri: {},
            dataPrivArr: [],
            lastSelectStatus: {},
            // 互斥选择的权限组
            exclusivePrivGroupMap: {
                terminal: ['terminal-customer-freindmark', 'terminal-freindmark'],
            },

            // 勾选联动
            checkRelatedMap: {
                'corp-friend-manager': 'corp-friend',
                // 'manager-IVR-yh': {
                //     group: 'smart-kefu',
                //     sub: 'zhiku'
                // }
            },

            unCheckRelatedMap: {
                'corp-friend': 'corp-friend-manager',
                // zhiku: {
                //     group: 'call-set',
                //     sub: 'manager-IVR-yh'git
                // }
            },
            // 取消勾选联动

            // 权限提示说明
            alertTips: {
                'terminal-external': this.$t('关闭此权限将无法与外部联系人/客户沟通，请慎重选择'),
                'reception-corp-auto-response': this.$t('关闭此权限将无法接待主号通路的客户'),
                'sale-crm': this.$t('关闭此权限将无法进行客户接待，请慎重选择'),
                'terminal-transfer': this.$t('此配置仅支持2.1以上版本的客户端'),
                'manage-report': this.$t('同时勾选管理>客户管理配置可查看全公司员工分析报表'),
                'manager-attendant-report': this.$t('请在"办公考勤-考勤设置"设定报表查看范围'),
                'tickets-lists': this.$t('该权限控制账户中心工单列表和客户端顶部工单入口'),
                'terminal-tickets': this.$t('需要拥有 "工单管理-工单列表" 权限'),
                'tickets-schedule-setting': this.$t('需要有工单处理组权限'),
                forbidden_corpuin_add_friend: this.$t('此配置仅支持3.5及以上版本'),
                forbidden_uin_add_friend: this.$t('此配置仅支持3.5及以上版本'),
                zhiku: this.$t('此部分权限为机器人专业版套餐能力'),
                jichushezhi: this.$t('关闭此权限可能会导致进入机器人提示无权限'),
                GPT_Settings: this.$t('不勾选该权限，可能会导致无法进入大模型机器人'),
            },

            // 旧版配置引导提示 根据开号时间判断新老用户
            oldTips: {
                6: {
                    tips: this.$t('设置后，当前角色下的员工将不再应用旧版本【消息查看范围】'),
                    link: '/cl/cuCfg/CuRulePage?_tab=5',
                },
            },
        };
    },

    computed: {
        showDataPriv() {
            let isShow = false;

            if (this.dataPrivOri && Object.keys(this.dataPrivOri).length > 0) {
                isShow = true;
            }

            return isShow;
        },

        checkedPackages() {
            const checkedPackageArr = [];
            this.featureCheckArr.forEach((item) => {
                item.subCheckArr.forEach((subItem) => {
                    if (item.subCheckModel.includes(subItem.id)) {
                        checkedPackageArr.push(subItem.packages);
                    }
                });
            });

            return checkedPackageArr;
        },
        checkedPrivItem() {
            const checkedArr = [];

            this.featureCheckArr.forEach((item) => {
                item.subCheckArr.forEach((subItem) => {
                    if (item.subCheckModel.includes(subItem.id)) {
                        subItem.privArr.forEach((pItem) => {
                            checkedArr.push({
                                id: parseInt(pItem.id, 10),
                                FType: parseInt(pItem.FType, 10),
                                hasQQPrivilege: subItem.hasQQPrivilege,
                                name: pItem.name,
                            });
                        });
                    }
                });
            });

            return checkedArr;
        },

        // 已勾选的非端权限位id数组
        checkedPrivIdArr() {
            const checkedIdArr = [];
            this.checkedPrivItem.forEach((item) => {
                if (item.FType !== 1) {
                    checkedIdArr.push(item.id);
                }
            });

            // 数组去重
            return Array.from(new Set(checkedIdArr));
        },

        // 已勾选的端权限位id数组
        checkedTerminalPrivIdArr() {
            const checkedIdArr = [];
            this.checkedPrivItem.forEach((item) => {
                if (item.FType === 1) {
                    checkedIdArr.push(item.id);
                }
            });

            // 数组去重
            return Array.from(new Set(checkedIdArr));
        },
    },

    watch: {
        errBoId() {},
    },

    created() {
        this.getPrivData();
        // this.privDataFormat();
    },

    mounted() {},

    methods: {
        handleGroupChange(index, config) {
            const currItem = this.featureCheckArr[index];
            const { group, sub, checked } = config || {};
            const { id, subCheckModel, subCheckArr, lastSubCheckModel } = currItem || {};
            let currKey;
            let handleCheckedArr = subCheckModel || [];

            // 跨组联动处理
            if (group && sub) {
                if (checked) {
                    handleCheckedArr = this.checkSubKey(subCheckModel, sub);
                } else {
                    handleCheckedArr = this.unCheckSubKey(subCheckModel, sub);
                }
            } else if (subCheckModel.length > lastSubCheckModel.length) {
                // 从上次currItem.subCheckModel的长度和新的subCheckModel长度判断是勾选还是取消勾选
                currKey = subCheckModel[subCheckModel.length - 1];
                // 勾选联动处理
                handleCheckedArr = this.checkHandle(subCheckModel, currKey);
                // 勾选互斥处理
                handleCheckedArr = this.exclusiveHandle(id, handleCheckedArr, currKey);
            } else if (subCheckModel.length < lastSubCheckModel.length) {
                // 取消勾选联动处理
                currKey = this.getUncheckedKey(subCheckModel, lastSubCheckModel);
                handleCheckedArr = this.unCheckHandle(subCheckModel, currKey);
            }
            currItem.subCheckModel = handleCheckedArr;
            currItem.isCheck = currItem.subCheckModel.length > 0;
            currItem.indeterminate = currItem.subCheckModel.length < subCheckArr.length;
            currItem.lastSubCheckModel = currItem.subCheckModel;
            this.initDataPriv();
            this.emitChange();
        },

        handleChange(index) {
            const currItem = this.featureCheckArr[index];
            const { id, subCheckArr } = currItem || {};
            let checkedArr = [];

            if (currItem.isCheck) {
                const allCheckedArr = subCheckArr.map(item => item.id);
                checkedArr = this.exclusiveHandle(id, allCheckedArr);
            }

            currItem.subCheckModel = checkedArr;
            this.emitChange();
        },

        getUncheckedKey(currArr, lastArr) {
            let unCheckedKey = '';

            lastArr.every((iKey) => {
                if (!currArr.includes(iKey)) {
                    unCheckedKey = iKey;
                    return false;
                }
                return true;
            });

            return unCheckedKey;
        },

        // 勾选联动处理
        // 1.当前勾选的key是已勾选数组的最后一项
        // 2.如果当前勾选key有勾选联动值并且没有在已勾选数组里，则在已勾选数据组里面加上勾选联动值
        // 3.返回完整的已勾选数组
        checkHandle(currArr, currKey) {
            const relatedKey = this.checkRelatedMap[currKey];

            if (relatedKey && relatedKey.group) {
                this.crosGroupCheckHandle(relatedKey, true);

                return currArr;
            }

            return this.checkSubKey(currArr, relatedKey);
        },

        // 取消勾选联动
        // 1.当前取消勾选的key是已勾选数组和上一次已勾选数组对比相差的key值
        // 2.如果当前取消勾选的key有取消勾选联动值，并且在已勾选数组里，则在已勾选数据组里面要去掉取消勾选联动
        // 3.返回完整的已勾选数组
        unCheckHandle(currArr, currKey) {
            const relatedKey = this.unCheckRelatedMap[currKey];

            if (relatedKey && relatedKey.group) {
                this.crosGroupCheckHandle(relatedKey, false);

                return currArr;
            }

            return this.unCheckSubKey(currArr, relatedKey);
        },

        checkSubKey(arr, key) {
            const handleArr = arr || [];
            if (key && !handleArr.includes(key)) {
                handleArr.push(key);
            }

            return handleArr;
        },

        unCheckSubKey(arr, key) {
            const handleArr = arr || [];

            if (key) {
                for (let len = handleArr.length, i = len - 1; i >= 0; i--) {
                    const iKey = handleArr[i];
                    if (key === iKey) {
                        handleArr.splice(i, 1);
                    }
                }
            }

            return handleArr;
        },

        // 跨组勾选联动处理
        crosGroupCheckHandle(config, checked) {
            const { group, sub } = config || {};
            let index = -1;

            this.featureCheckArr.some((item, k) => {
                const { id } = item || {};

                if (id === group) {
                    index = k;
                    return true;
                }

                return false;
            });

            if (index > -1) {
                this.handleGroupChange(index, {
                    group,
                    sub,
                    checked,
                });
            }
        },

        // 勾选互斥处理
        exclusiveHandle(parentKey, checkedArr, currCheckedKey) {
            let exclusivePrivArr = this.exclusivePrivGroupMap[parentKey] || [];
            const calCheckedArr = checkedArr || [];
            const excludeKey = currCheckedKey || exclusivePrivArr[0];

            if (
                excludeKey
                && exclusivePrivArr.includes(excludeKey)
                && calCheckedArr.length > 0
                && calCheckedArr.includes(excludeKey)
            ) {
                // 如果有子级勾选操作，当前勾选的子级权限保留勾选态， 所在互斥组其他权限取消勾选态
                // 如果是父级全选的情况，互斥组内第一个权限勾选态保留，其他勾选态取消
                exclusivePrivArr = exclusivePrivArr.filter(exKey => exKey !== excludeKey);

                for (let len = calCheckedArr.length, i = len - 1; i >= 0; i--) {
                    const checkedKey = calCheckedArr[i];
                    if (exclusivePrivArr.includes(checkedKey)) {
                        calCheckedArr.splice(i, 1);
                    }
                }
            }

            return calCheckedArr;
        },

        getPrivData() {
            this.loading = true;
            this.$ajax.read('/mng/role/GetPrivilegesList', this.reqParam).then(
                (res) => {
                    const r = res || {};
                    this.featurePrivOri = r.privileges || {};
                    this.dataPrivOri = r.data_privileges || {};
                    this.copyDataPriv = { ...this.dataPrivOri };
                    this.initFeaturePriv();
                    this.initDataPriv();
                    this.loading = false;
                    this.$emit('init', this.getExportData());
                },
                (error) => {
                    this.$message.error((error && error.message) || this.$t('加载失败，请稍后重试'));
                    this.loading = false;
                },
            );
        },

        initFeaturePriv() {
            const featureCheckArr = [];
            Object.keys(this.featurePrivOri).forEach((k) => {
                const fItem = this.featurePrivOri[k];
                let isCheck = false;
                let indeterminate = false;

                if (fItem && fItem.items) {
                    const subCheckArr = [];
                    const subCheckModel = [];

                    Object.keys(fItem.items).forEach((sk) => {
                        const subItem = fItem.items[sk];
                        const privArr = [];

                        if (subItem.list && subItem.list.length) {
                            subItem.list.forEach((privItem) => {
                                privArr.push(privItem);
                            });
                        }

                        subCheckArr.push({
                            id: sk,
                            name: this.$t(subItem.name),
                            ab: subItem.ab,
                            alertTip: this.alertTips[sk],
                            packages: subItem.packages,
                            hasQQPrivilege: subItem.hasQQPrivilege,
                            privArr,
                        });

                        if (parseInt(subItem.checked, 10) === 1) {
                            subCheckModel.push(sk);
                        }
                    });

                    if (subCheckModel.length > 0) {
                        isCheck = true;
                    }

                    if (subCheckModel.length < subCheckArr.length) {
                        indeterminate = true;
                    }

                    featureCheckArr.push({
                        id: k,
                        name: this.$t(fItem.name),
                        lastSubCheckModel: [...subCheckModel],
                        isCheck,
                        indeterminate,
                        subCheckArr,
                        subCheckModel,
                    });
                }
            });

            this.featureCheckArr = featureCheckArr;
        },

        initDataPriv() {
            const dataPrivArr = [];
            Object.keys(this.copyDataPriv).forEach((k) => {
                const item = this.copyDataPriv[k];
                const fItem = this.featurePrivOri[k];
                const setArr = [];

                item.forEach((sItem) => {
                    // 选项数据
                    const optArr = this.getCombineOpts(sItem);
                    setArr.push({
                        id: sItem.bo_id,
                        name: this.$t(sItem.name),
                        optArr,
                    });
                });

                dataPrivArr.push({
                    id: k,
                    name: this.$t(fItem && fItem.name),
                    setArr,
                });
            });

            this.dataPrivArr = dataPrivArr;
        },

        // meta数据组合成下拉选项数据
        getCombineOpts(item) {
            const { metas, pris } = item || {};
            const combineArr = [];

            // 选项数据
            const optArr = metas.filter(mItem => parseInt(mItem.type, 10) === 1);

            // 操作类型数据
            const operateArr = metas.filter(mItem => parseInt(mItem.type, 10) === 2);

            operateArr.forEach((operateItem) => {
                const options = [];
                const isDisabled = this.isDisableSelect(pris, item.terminal_pris);

                let isMulti = false;
                let currVal = operateItem.scope || [];

                optArr.forEach((optItem) => {
                    options.push({
                        text: this.$t(optItem.description),
                        value: optItem.name,
                        groupId: optItem.group,
                    });
                });
                isMulti = this.isMultiSelect(options);

                if (!isMulti && Array.isArray(currVal)) {
                    [currVal] = currVal;
                }

                combineArr.push({
                    id: operateItem.name,
                    currVal,
                    isMulti,
                    operateTxt: this.$t(operateItem.description),
                    placeholder: `${this.$t(operateItem.description)}：-`,
                    disabled: isDisabled,
                    options,
                });
            });
            return combineArr;
        },

        hasMultiPri(item) {
            if (item && item.privArr && item.privArr.length > 1) {
                return true;
            }

            return false;
        },

        getPrivTip(subItem) {
            const { privArr } = subItem || {};

            return privArr.map(item => this.$t(item.name)).join('/');
        },

        isDisableSelect(privs, terminalPrivs) {
            let disabled = true;

            if (privs && privs.length > 0) {
                privs.every((id) => {
                    if (this.checkedPrivIdArr.includes(parseInt(id, 10))) {
                        disabled = false;
                        return false;
                    }
                    return true;
                });
            }

            if (terminalPrivs && terminalPrivs.length > 0) {
                terminalPrivs.every((id) => {
                    if (this.checkedTerminalPrivIdArr.includes(parseInt(id, 10))) {
                        disabled = false;
                        return false;
                    }
                    return true;
                });
            }

            return disabled;
        },

        /**
         * 最小套餐配额计算
         * 最终计算得出没有交集的套餐列表的二维数组，如果都是长度为1的数组元素则直接push的要提交的packages参数，如果有长度为2及以上的数组需要弹框让用户选择用哪个套餐
         * 例：[[10001], [10001, 10002], [10002, 10003], [10004, 10005],
          [10002, 10004, 10005]] -> [[10001],[10002],[10004,10005]] 需要弹框询问用户要用10004还是10005套餐
         */
        getNoIntersectionPackages() {
            const noIntersectionArr = [];
            this.checkedPackages.forEach((tItem) => {
                let hasIntersection = false;
                noIntersectionArr.every((nItem, nIndex) => {
                    const intersection = tItem.filter(v => nItem.indexOf(v) > -1);

                    if (intersection.length > 0) {
                        noIntersectionArr.splice(nIndex, 1, intersection);
                        hasIntersection = true;
                        return false;
                    }
                    return true;
                });

                if (!hasIntersection) {
                    noIntersectionArr.push(tItem);
                }
            });

            // noIntersectionArr里面长度为1的数组元素直接push到packages，大于1的需要用户选择
            return noIntersectionArr;
        },

        emitChange() {
            this.$emit('change', this.getExportData());
        },

        selectChange(setKey, boIndex, metaName, val) {
            const metaArr = this.copyDataPriv[setKey][boIndex].metas;

            metaArr.forEach((mItem, mIndex) => {
                if (parseInt(mItem.type, 10) === 2 && mItem.name === metaName) {
                    // metaArr[mIndex].scope[0] = val;
                    metaArr[mIndex].scope = val; // 多选兼容处理
                }
            });

            this.emitChange();
        },

        getExportData() {
            return {
                checkedPrivIdArr: this.checkedPrivIdArr,
                checkedPrivItem: this.checkedPrivItem,
                checkedTerminalPrivIdArr: this.checkedTerminalPrivIdArr,
                noIntersectionPackages: this.getNoIntersectionPackages(),
                dataPriv: this.getSelectedDataPriv(),
            };
        },

        // 非disable状态的数据权限规则
        getSelectedDataPriv() {
            const selectedDataPriv = [];
            Object.keys(this.copyDataPriv).forEach((key) => {
                const boArr = this.copyDataPriv[key];

                boArr.forEach((item) => {
                    if (!this.isDisableSelect(item.pris, item.terminal_pris)) {
                        item.metas.forEach((mItem) => {
                            if (parseInt(mItem.type, 10) === 2) {
                                // 多选兼容处理
                                if (Array.isArray(mItem.scope)) {
                                    mItem.scope.forEach((scope) => {
                                        selectedDataPriv.push({
                                            bo_id: item.bo_id,
                                            op: mItem.name,
                                            scope,
                                        });
                                    });
                                } else {
                                    selectedDataPriv.push({
                                        bo_id: item.bo_id,
                                        op: mItem.name,
                                        scope: mItem.scope,
                                    });
                                }
                            }
                        });
                    }
                });
            });

            return selectedDataPriv;
        },

        // 只有从disable切换成可选择状态才闪烁
        getAnimateClass(sId, item) {
            const statusKey = `${sId}_${item.id}`;
            let animateClass = '';
            let lastStatus = true;

            if (typeof this.lastSelectStatus[statusKey] !== 'undefined') {
                lastStatus = this.lastSelectStatus[statusKey];
            }

            if (!item.disabled && !lastStatus) {
                animateClass = 'select-blink-animate';
            }

            if (sId === this.errBoId) {
                animateClass = `${animateClass} priv-data-choice-select-err`;
            }

            this.lastSelectStatus[statusKey] = !item.disabled;

            return animateClass;
        },

        // 客户库多选互斥
        selectClick(item) {
            if (!item.isMulti) {
                return;
            }
            const { currVal, options } = item || {};
            const groupMap = {};
            const lastSelectedVal = currVal[currVal.length - 1];
            let lastGroupId = -1;

            options.forEach((oItem) => {
                if (oItem.value === lastSelectedVal) {
                    lastGroupId = oItem.groupId;
                }

                if (!groupMap[oItem.groupId]) {
                    groupMap[oItem.groupId] = [];
                }

                groupMap[oItem.groupId].push(oItem.value);
            });

            // 不同groupId的选项勾选互斥
            for (let len = currVal.length, i = len - 2; i >= 0; i--) {
                const val = currVal[i];
                const groupValArr = groupMap[lastGroupId];

                if (groupValArr.indexOf(val) === -1) {
                    item.currVal.splice(i, 1);
                }
            }
        },

        getMultiSelectTxt(item) {
            const selectedOptions = item.options.filter(oItem => item.currVal.indexOf(oItem.value) > -1);

            return selectedOptions.map(sItem => sItem.text).join(', ') || '-';
        },

        isMultiSelect(options) {
            const groupMap = {};

            options.forEach((oItem) => {
                if (!groupMap[oItem.groupId]) {
                    groupMap[oItem.groupId] = [];
                }

                groupMap[oItem.groupId].push(oItem.value);
            });

            if (Object.keys(groupMap).length > 1) {
                return true;
            }

            return false;
        },

        showOldTips(item) {
            const config = this.oldTips[item.id];
            let isShow = false;

            if (config && !item.corp_new) {
                isShow = true;
            }

            return isShow;
        },

        mktPackage(item) {
            let res = false;
            item.forEach((ele) => {
                if (ele.id === 13) {
                    res = true;
                }
            });
            return res;
        },
    },
};
</script>

<style lang="less">
@import './index.less';
</style>
